<template>
  <div v-if="[1, 2].includes(transaction.categoryId)">
    <div v-if="loading" id="loading">
      <Card>
        <template v-slot:content>
          <div class="p-grid">
            <div class="p-col-4" v-for="index in 6" :key="index">
              <Skeleton width="100%" height="23px" />
            </div>
          </div>
        </template>
      </Card>
    </div>
    <router-link
      v-if="sale && !loading"
      :to="{ name: 'sale.edit', params: { id: sale.id } }"
      style="text-decoration: none"
    >
      <SaleSummaryCard :sale="sale"></SaleSummaryCard>
    </router-link>
    <router-link
      v-if="service && !loading"
      :to="{ name: 'service.edit', params: { id: service.id } }"
      style="text-decoration: none"
    >
      <ServiceSummaryCard :service="service"></ServiceSummaryCard>
    </router-link>
  </div>
</template>

<script>
import { SaleApi, ServiceApi } from '../../../services/api';
import SaleSummaryCard from '../../Sale/components/SaleSummaryCard.vue';
import ServiceSummaryCard from '../../Service/components/ServiceSummaryCard.vue';

export default {
  name: 'CashFlowRelated',
  components: {
    SaleSummaryCard,
    ServiceSummaryCard,
  },
  props: {
    transaction: Object,
  },
  data() {
    return {
      sale: null,
      service: null,
      loading: false,
    };
  },
  watch: {
    transaction(newData) {
      if (
        newData.id &&
        newData.categoryId === 1 &&
        this.$ability.can('read', 'Sale')
      ) {
        this.fetchSale();
      }
      if (
        newData.id &&
        newData.categoryId === 2 &&
        this.$ability.can('read', 'Service')
      ) {
        this.fetchService();
      }
    },
  },
  methods: {
    async fetchSale() {
      try {
        this.loading = true;
        const saleResponse = await SaleApi.fetch({
          transactionId: this.transaction.id,
        });
        this.sale = saleResponse.results[0];
      } finally {
        this.loading = false;
      }
    },
    async fetchService() {
      try {
        this.loading = true;
        const serviceReponse = await ServiceApi.fetch({
          transactionId: this.transaction.id,
        });
        this.service = serviceReponse.results[0];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
#loading >>> .p-card-content {
  padding: 0 !important;
}
</style>